import { Button, Card, EmptyState } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../context/page-context';

export function ShippingMethodsEmptyState() {
  const { navigationHandler } = useHandlers();

  return (
    <Card>
      <EmptyState
        title={t('features:shipping_methods.components.shipping_methods_empty_state.title')}
        subtitle={t(
          'features:shipping_methods.components.shipping_methods_empty_state.description',
        )}
        imageType="shippingMethod"
      >
        <Button
          icon="plusCircle"
          onClick={() => navigationHandler.navigate('/configuration/shipping/create')}
        >
          {t('features:shipping_methods.components.shipping_methods_empty_state.create')}
        </Button>
      </EmptyState>
    </Card>
  );
}
